var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge badge-pill d-inline-flex align-items-center",class:[_vm.variantClass, _vm.badgeType]},[_vm._v(" "+_vm._s(_vm.value)+" "),(_vm.deletable)?_c('i',{staticClass:"fd-close ml-1 cursor-pointer",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('delete')}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }